import { Host, Input, Optional, SkipSelf } from '@angular/core';
import { AbstractControl, ControlContainer, FormControl } from '@angular/forms';
import { ValueAccessorBase } from './value-accessor-base';

export abstract class FormControlBase<T> extends ValueAccessorBase<T> {
  /**
   * Implement: insert @Input at formControlName
   * e.g. @Input() formControlName: string
   */
  @Input() formControlName: string;
  @Input() formControl: FormControl;
  @Input() initValue: any;
  @Input() submitted: boolean;
  @Input() errors: any;
  public control: AbstractControl;
  @Input() browserIE = false;

  protected constructor(
    @Optional() @Host() @SkipSelf()
    protected controlContainer: ControlContainer
  ) { super(); }

  /**
   * Call the function checkInitialControl in the OnInit function
   */
  public checkInitialControl() {
    if (this.controlContainer) {
      if (this.formControlName) {
        this.control = this.controlContainer.control.get(this.formControlName);
      } else if (this.formControl) {
        this.control = this.formControl;
      } else {
        // console.warn(`Missing FormControlName '${this.formControlName}' directive from host element of the component`);
      }
    } else {
      // console.warn(`Can\'t find parent FormGroup directive for FormControlName '${this.formControlName}'`);
    }

    if (this.control && this.initValue) {
      this.control.setValue(this.initValue);
    }
  }
}
